/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
export { default as wrapRootElement } from "./src/state/ReduxWrapper"

const getRedirectLanguage = () => {
  if (typeof window !== "undefined") {
    if (typeof navigator === `undefined`) {
      return "en"
    }

    const lang = navigator && navigator.language && navigator.language.split("-")[0]
    if (!lang) return "en"

    switch (lang) {
      case "ro":
        return "ro"
      case "de":
        return "de-at"
      default:
        return "en"
    }
  }
}

if (typeof window !== "undefined") {

  if (window.location.hostname === "heidi.ro") {
    window.location.href = "https://heidi-chocolate.com/ro" + window.location.pathname
  }
    if (window.navigator && getRedirectLanguage() === 'ro') {
      if (window.location.href !== 'https://heidi-chocolate.com/ro/' && window.location.pathname.split('/')[1] !== 'ro' && !window.location.href.includes('localhost')) {
        window.location.href = "https://heidi-chocolate.com/ro" + window.location.pathname
    }
  }

  if (window.navigator && getRedirectLanguage() === 'de-at') {
    if (window.location.href !== 'https://heidi-chocolate.com/de-at/' && window.location.pathname.split('/')[1] !== 'de-at' && !window.location.href.includes('localhost')) {
      window.location.href = "https://heidi-chocolate.com/de-at" + window.location.pathname
    }
  }
}
